/**
 * Подписывается на публичный канал уведомлений, перезагружает страницу,
   если пользователь авторизовался с помощью Telegram
 */

import { updateNotificationsCount } from "../../../../components/notifications/update-count";
import { loadNotifications } from "../../../../components/notifications/index";

const subscriber = (rt) => {
  rt.subscribePublic("notify-everything", data => {
    console.log('notify-everything', data);

    if (data.message) {
      const count = (window.notificationsCount || 0) + 1;
      window.notificationsCount = count;
      window.notificationsHTML = window.notificationsHTML ? window.notificationsHTML : '';
      window.notificationsHTML += `<div class="notification-preview flex">
        <div class="notification__content">
          <div class="notification__title mb-2 flex flex-wrap">
            ${data.message}
          </div>
        </div>
      </div>`;

      // '{{ path("api_notifications_fetch") }}', this

      loadNotifications("/u/notifications/fetch",
        document.querySelector("header [data-notifications-marker]"),
        true);

    }
  });
}

export default subscriber;